import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loadImage from '../../utils/loadImage';
import style from './BackgroundLoad.module.scss';

class BackgroundLoad extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      reveal: false,
    };
  }
  componentDidMount() {
    this.load();
  }
  load() {
    loadImage(this.props.src).then(img => {
      if (this.props.onLoadComplete) {
        this.props.onLoadComplete();
      }
      this.setState({ loaded: true }, () => {
        setTimeout(this.reveal, 10);
      });
    });
  }
  reveal = () => {
    this.setState({ reveal: true });
  };

  render() {
    const loadStyle = {
      backgroundImage: this.state.loaded ? `url(${this.props.src})` : '',
      opacity: this.state.reveal ? this.props.opacity : 0,
    };

    return (
      <div>
        <div className={`${style.backgroundLoad}`} style={loadStyle} />
        <noscript
          dangerouslySetInnerHTML={{
            __html: `<div class="${
              style.lazyBackground
            }" style="backgroundImage: url(${this.props.src}); opacity: ${
              this.props.opacity ? this.props.opacity : 1
            };"></div>`,
          }}
        />
      </div>
    );
  }
}

export default BackgroundLoad;



// WEBPACK FOOTER //
// ./src/components/ui/BackgroundLoad.js